import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { PlantusLogo } from "@/components/plantus/Logo";

export const LegalShell = ({ title, lastUpdated, children, testId }) => (
  <div className="min-h-screen bg-bone" data-testid={testId}>
    <header className="border-b border-bone-200/70 bg-bone/80 backdrop-blur sticky top-0 z-30">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/">
          <PlantusLogo size="lg" />
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-forest-700 hover:text-forest-900 px-3 py-2 rounded-full"
        >
          <ArrowLeft size={16} weight="bold" /> Zurück
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-forest-900 tracking-tight">
        {title}
      </h1>
      {lastUpdated && (
        <p className="mt-3 text-sm text-[#7A827C]">Stand: {lastUpdated}</p>
      )}
      <div className="mt-10 space-y-8 font-body text-[15px] leading-relaxed text-[#3A423D]">
        {children}
      </div>
    </main>
  </div>
);

export const Section = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-xl font-semibold text-forest-900 mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);
